<script setup lang="ts">
import type { YscDateRange } from '../../types'
import { useNuxtApp } from '#imports'

interface Props {
  dates?: YscDateRange
  destination?: string
}

withDefaults(defineProps<Props>(), {
  dates: undefined,
  destination: undefined,
})

const { $i18n: { locale } } = useNuxtApp()

const emits = defineEmits(['openSearchDestinations'])
</script>

<template>
  <button
    class="w-full rounded border border-gray-300 text-left py-2 px-4 text-sm"
    @click.prevent.stop="emits('openSearchDestinations')"
  >
    <p
      v-if="!destination"
      class="text-gray-500"
    >
      {{ $t('data.search.destination.label') }}
    </p>
    <p v-else>
      {{ destination }}
    </p>
    <p
      v-if="!dates.start || !dates.end"
      class="text-gray-500"
    >
      {{ $t('data.search.dates.label') }}
    </p>
    <p
      v-else
      class="flex"
    >
      {{ $d(new Date(dates.start), 'Y.numeric M.2digit D.numeric', locale) }}
      -
      {{ $d(new Date(dates.end), 'Y.numeric M.2digit D.numeric', locale) }}
    </p>
  </button>
</template>
